import React from 'react'
import { defaultProps } from './index'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const BlogImageGallerySettings = (settingsProps) => {
  return (
    <>
      {!settingsProps.floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const BlogImageGalleryFloatingSettings = () =>
  React.createElement(BlogImageGallerySettings, { floating: true })
